import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';

export const GLOSSARY_FILTER_DEFAULT_SORT_OPTION = 'alphabetical';

class GlossaryFilterStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      currentSortOption: GLOSSARY_FILTER_DEFAULT_SORT_OPTION,
      currentFilterTagList: [],
      letterRange: null,
    };
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.GLOSSARY_UPDATE_FILTER:
        return {
          ...state,
          currentSortOption: action.filter.currentSortOption,
          currentFilterTagList: action.filter.currentFilterTagList,
        };

      case ActionTypes.GLOSSARY_UPDATE_LETTER_RANGE:
        return {
          ...state,
          letterRange: action.letterRange,
        };

      // We make sure to reset the filters when leaving the Glossary (on mobile,
      // it's not required on Tablet and Desktop).
      case ActionTypes.MODAL_FULLSCREEN_CLOSED:
        return this.getInitialState();

      default:
        return state;
    }
  }
}

export default new GlossaryFilterStore();
